// extracted by mini-css-extract-plugin
export default {"global-layout":"Global_global-layout__PTDHJ","global-layout__body":"Global_global-layout__body__anTXP","global-layout__body--body":"Global_global-layout__body--body__HEZuG"};